// army-trail-stop.js                                        ~/js/swipers
///////////////////////////////////////////////////////////////////////////

import Swiper from 'swiper';
import ModalSwiper from './modal';
import { Navigation, Pagination } from 'swiper/modules';

// Army Trails Page - Trails Swiper
export const ArmyTrailStopSwiper = new Swiper('.army-trail-stop-swiper', {
  modules: [Navigation, Pagination],
  slidesPerView: 'auto',
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  autoplay: false,
  on: {
    click: (_, event) => {
      if (event.target.closest('.swiper-wrapper') != null) {
        // Create a new dom element for the swiper modal
        const createModal = document.createElement('div');
        createModal.className = 'modal';
        createModal.innerHTML = `
        <div class="media-modal-container">
        <div class="close"></div>

        <div class="swiper-container modal-swiper">

        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        </div>
        </div>
        `;

        // Append all slides from the swiper that was clicked into the newly created modal swiper
        const currCollection = event.target
          .closest('.swiper-wrapper')
          .cloneNode(true);
        document.body.appendChild(createModal);
        document
          .querySelector('.modal .modal-swiper')
          .appendChild(currCollection);

        // Animate the opening of the modal
        const overlay = document.querySelector('.media-modal-container');
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          overlay.classList.add('showing');
        }, 100);

        // Initialize the modal swiper starting at the slide that was clicked
        const slideId = [
          ...event.target.closest('.swiper-wrapper').children,
        ].indexOf(event.target.closest('.swiper-slide'));
        ModalSwiper(slideId);

        // Close and destroy the modal
        const slideClose = document.querySelector(
          '.media-modal-container .close',
        );
        slideClose.addEventListener('click', () => {
          const thisModal = document.querySelector('.modal');
          overlay.classList.remove('showing');
          setTimeout(() => {
            document.body.style.overflow = null;
            thisModal.parentNode.removeChild(thisModal);
          }, 300);
        });
      }
    },
  },
});
